import React from "react"
import { Grid, Typography, TextField, Button, makeStyles, createStyles, Theme } from "@material-ui/core"
import { Link } from 'react-router-dom';
import BackgroundImage from '../../resources/images/background.jpg'

const useStyles = makeStyles((theme: Theme) => createStyles({
    container: {
        minHeight: "100vh",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover"
    },
}));

const Login: React.FC = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Grid className={classes.container} container direction="column" justify="center" alignItems="center">
                <Grid item>
                    <Typography variant="h2">
                        Infiniti Cosmetics
                </Typography>
                </Grid>
                <Grid item>
                    <TextField placeholder="username" />
                </Grid>
                <Grid item>
                    <TextField placeholder="password" />
                </Grid>
                <Grid item>
                    <Button style={{}} component={Link} to="/chooser">Login</Button>
                </Grid>
            </Grid>
        </div>
    )
}

export default Login;
